/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const OnboardingStatus = {
    Incomplete: 'Incomplete',
    Complete: 'Complete'
};
export function OnboardingStatusFromJSON(json) {
    return OnboardingStatusFromJSONTyped(json, false);
}
export function OnboardingStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function OnboardingStatusToJSON(value) {
    return value;
}
